import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]
  static values = { clampClass: String }

  connect() {
    if (this.contentTarget.scrollHeight > this.contentTarget.clientHeight + 1) {
      this.toggleTarget.classList.remove("hidden")
    }
  }

  toggle() {
    const clamped = this.contentTarget.classList.toggle(this.clampClassValue)
    this.toggleTarget.textContent = clamped ? "Lire plus" : "Cacher"
  }
}
